import { SourcingStats } from 'api-clients/monolith';

import { HiringOpeningsHoverCard } from '@/components/pages/dashboard/dashboard-table/hiring-openings-hover-card';
import { Typography, TypographyVariant } from '@/components/ui/typography';

interface HireStatsProps {
  stats: SourcingStats;
  typographyVariant?: TypographyVariant;
  isHighlighted?: boolean;
  openingSlug: string;
}

export function HireStats({
  stats,
  typographyVariant = 'text',
  isHighlighted = false,
  openingSlug,
}: HireStatsProps) {
  const { expected, actual } = stats;

  const renderActual = () => {
    if (!actual) return '-';

    if (isHighlighted) {
      return (
        <HiringOpeningsHoverCard openingSlug={openingSlug}>
          <Typography
            variant={typographyVariant}
            className="!text-fx-blue bg-fx-blue-50 rounded-full px-1.5 py-0.5"
          >
            {actual}
          </Typography>
        </HiringOpeningsHoverCard>
      );
    }

    return <Typography variant={typographyVariant}>{actual}</Typography>;
  };

  return (
    <div className="flex items-center gap-1">
      {renderActual()}

      <span>/</span>

      <Typography variant={typographyVariant}>{expected ?? '-'}</Typography>
    </div>
  );
}
